import { render } from "./NetworkTwa.vue?vue&type=template&id=195f9d95&scoped=true"
import script from "./NetworkTwa.vue?vue&type=script&lang=js"
export * from "./NetworkTwa.vue?vue&type=script&lang=js"

import "./NetworkTwa.vue?vue&type=style&index=0&id=195f9d95&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195f9d95"]])

export default __exports__